<template>
  <treeselect
    :multiple="false"
    :options="portfolio"
    :show-count="true"
    :searchable="false"
    :clearable="false"
    placeholder="Selecione seu investimento"
    v-model="select_portfolio_id"
    @select="selectPortfolio"
    class="h-10"
  >
    <div slot="option-label" slot-scope="{ node, labelClassName }" :class="labelClassName" class="py-2">
      <div class="flex items-center justify-between" v-for="(item, index) in list_portfolio" :key="index">
        <div class="space-x-3" v-if="node.id == item.investment_id">
          <span
            v-show="item.investment_id != 0"
            class="relative -mb-3 inline-flex h-3 w-3 items-center"
            :content="
              item.investment_status === 'STOPPED'
                ? 'Investimento parado'
                : item.investment_status === 'RUNNING'
                  ? 'Investimento em execução'
                  : 'Investimento arquivado'
            "
            v-tippy="{
              arrow: true,
              theme:
                item.investment_status === 'STOPPED' ? 'red' : item.investment_status === 'RUNNING' ? 'green' : 'gray',
            }"
          >
            <span
              :class="
                item.investment_status == 'STOPPED'
                  ? 'bg-ontick-red-500'
                  : item.investment_status == 'RUNNING'
                    ? 'bg-ontick-green-500 animate-ping'
                    : 'bg-gray-400'
              "
              class="absolute inline-flex h-full w-full rounded-full opacity-75"
            ></span>

            <span
              class="relative inline-flex h-3 w-3 rounded-full"
              :class="
                item.investment_status == 'STOPPED'
                  ? 'bg-ontick-red-500'
                  : item.investment_status == 'RUNNING'
                    ? 'bg-ontick-green-500'
                    : 'bg-gray-400'
              "
            ></span>
          </span>
          <!-- <span class="text-ontick-blue-500 inline-flex text-sm">{{
            item.investment_id
          }}</span> -->
          <span v-if="item.investment_id != 0" class="text-ontick-blue-500 inline-flex text-sm">{{ node.id }}</span>
          <span class="text-ontick-steel-900 text-sm dark:text-gray-300">{{ node.label }}</span>
        </div>
        <div
          class="text-ontick-steel-900 float-right ml-2 text-sm dark:text-gray-300"
          v-if="node.id == item.investment_id"
        >
          <div
            content="Ordens executadas"
            v-tippy="{ arrow: true, theme: 'green' }"
            v-show="item.investment_status != 'HIDDEN'"
            class="mx-2 inline-flex items-center"
          >
            <p class="mx-2">{{ item.num_positions }}</p>
          </div>
        </div>
      </div>
    </div>
    <div slot="value-label" slot-scope="{ node }" class="w-full">
      <div class="flex items-center justify-between" v-for="(item, index) in list_portfolio" :key="index">
        <div class="space-x-3" v-if="node.id == item.investment_id">
          <span
            v-if="item.investment_id != 0"
            class="relative -mb-3 inline-flex h-3 w-3 items-center"
            :content="
              item.investment_status === 'STOPPED'
                ? 'Investimento parado'
                : item.investment_status === 'RUNNING'
                  ? 'Investimento em execução'
                  : 'Investimento arquivado'
            "
            v-tippy="{
              arrow: true,
              theme:
                item.investment_status === 'STOPPED' ? 'red' : item.investment_status === 'RUNNING' ? 'green' : 'gray',
            }"
          >
            <span
              :class="
                item.investment_status == 'STOPPED'
                  ? 'bg-ontick-red-500'
                  : item.investment_status == 'RUNNING'
                    ? 'bg-ontick-green-500 animate-ping'
                    : 'bg-gray-400'
              "
              class="absolute inline-flex h-full w-full rounded-full opacity-75"
            ></span>

            <span
              class="relative inline-flex h-3 w-3 rounded-full"
              :class="
                item.investment_status == 'STOPPED'
                  ? 'bg-ontick-red-500'
                  : item.investment_status == 'RUNNING'
                    ? 'bg-ontick-green-500'
                    : 'bg-gray-400'
              "
            ></span>
          </span>
          <span v-if="item.investment_id != 0" class="text-ontick-blue-500 inline-flex text-sm">{{
            item.investment_id
          }}</span>
          <span class="text-ontick-steel-900 text-sm dark:text-gray-300">{{ node.label }}</span>
        </div>
        <div
          class="text-ontick-steel-900 float-right ml-2 text-sm dark:text-gray-300"
          v-if="node.id == item.investment_id"
        >
          <div
            content="Ordens executadas"
            v-tippy="{ arrow: true, theme: 'green' }"
            v-show="item.investment_status != 'HIDDEN'"
            class="mx-2 inline-flex items-center"
          >
            <p class="text-ontick-steel-900 mx-2 dark:text-gray-300">
              {{ item.num_positions }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </treeselect>
</template>

<script>
import { mapActions } from "vuex";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";

export default {
  name: "portfolio-chart-header",
  components: {
    Treeselect,
    VueCtkDateTimePicker,
    menuMobile: () => import("./chart-header-mobile.component.vue"),
  },
  props: {
    data: {
      type: Object,
      default: null,
    },
    // select_portfolio_id: {
    //   type: Number,
    //   default: 0,
    // },
  },
  data() {
    return {
      portfolio: [],
      list_portfolio: [],
      select_portfolio: {},
      select_portfolio_id: Number(this.$route.query.portfolioId || 0),
      range: true,
    };
  },

  created() {
    this.initListInvestment(this.data);
  },
  methods: {
    ...mapActions({
      toggleAccount: "performance/toggleAccount",
    }),

    initListInvestment(value) {
      let portfolio_array = [];
      let order_by = { stopped: [], running: [], hidden: [] };

      portfolio_array.push({
        investment_id: 0,
        investment_name: "Selecione uma estratégia",
      });

      value.accounts.forEach((item_account) => {
        item_account.investments
          .filter((item) => item.investment_type === "PORTFOLIO")
          .forEach((item) => {
            portfolio_array.push(item);
            let new_investment;
            if (item.investment_status == "STOPPED") {
              new_investment = {
                label: item.investment_name,
                id: item.investment_id,
              };

              order_by.stopped.push(new_investment);
            } else if (item.investment_status == "RUNNING") {
              new_investment = {
                label: item.investment_name,
                id: item.investment_id,
              };

              order_by.running.push(new_investment);
            } else {
              new_investment = {
                label: item.investment_name,
                id: item.investment_id,
              };

              order_by.hidden.push(new_investment);
            }
          });
      });

      this.portfolio = [
        {
          id: 0,
          label: "Selecione um portfólio",
          isDisabled: true,
        },
        ...order_by.running,
        ...order_by.stopped,
        ...order_by.hidden,
      ];

      const portfolioIndex = this.portfolio.findIndex((item) => item.id === this.select_portfolio_id);

      this.select_portfolio = this.portfolio[portfolioIndex];
      this.select_portfolio_id = this.portfolio[portfolioIndex].id;
      this.list_portfolio = portfolio_array;

      this.selectPortfolio(this.select_portfolio);
    },

    selectPortfolio(portfolio) {
      this.select_portfolio = portfolio;
      let data_portfolio = {};

      let index = this.list_portfolio.findIndex((item) => item.investment_id == portfolio.id);
      if (index != -1) {
        data_portfolio = this.list_portfolio[index];
      }

      this.$emit("listInvestment", { ...data_portfolio });
    },
  },

  watch: {
    data(value) {
      this.initListInvestment(value);
      return value;
    },
  },

  unmounted: function () {
    this.portfolio = [];
  },
};
</script>

<style lang="scss">
@import "./chart-header.component.scss";
</style>
